<template>
  <div style="height: 400px; max-width: 100%; width: 99%;">
    <Line :data="chartData" :options="chartOptions" />
  </div>
</template>

<script>
import { Chart as ChartJS, Title, Tooltip, Legend, LineElement, PointElement, CategoryScale, LinearScale } from 'chart.js'
import { Line } from 'vue-chartjs'

ChartJS.register(Title, Tooltip, Legend, LineElement, PointElement, CategoryScale, LinearScale)

export default {
  name: 'ComparativeLineChart',
  components: { Line },
  props: {
    labels: { type: Array, required: true }, // ej: ['Ene', 'Feb', ..., 'Dic']
    periodoActual: { type: Array, required: true }, // ej: [120, 150, 180, ...]
    periodoAnterior: { type: Array, required: true } // ej: [100, 130, 160, ...]
  },
  computed: {
    chartData () {
      return {
        labels: this.labels,
        datasets: [
          {
            label: 'Periodo Actual',
            data: this.periodoActual,
            borderColor: '#222222',
            backgroundColor: '#222222',
            tension: 0.4,
            fill: false,
            pointRadius: 5
          },
          {
            label: 'Periodo Anterior',
            data: this.periodoAnterior,
            borderColor: '#FB925A',
            backgroundColor: '#FB925A',
            tension: 0.4,
            fill: false,
            pointRadius: 5
          }
        ]
      }
    },
    chartOptions () {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { position: 'top' },
          title: { display: false }
        },
        scales: {
          y: { beginAtZero: true }
        }
      }
    }
  }
}
</script>
